import { recoilSelector } from 'common/util/recoil-selector';
import { ComponentsTheme, THEMED_COMPONENT } from '../themes';
import { createStylesGetter } from '../utils';

const prepareCodeMirrorTheme = (codeMirrorTheme: ComponentsTheme[THEMED_COMPONENT.CODE_MIRROR]): string =>
  codeMirrorTheme.theme;

export const codeMirrorThemeState = recoilSelector({
  key: THEMED_COMPONENT.CODE_MIRROR,
  get: createStylesGetter(prepareCodeMirrorTheme, THEMED_COMPONENT.CODE_MIRROR),
});
